<template>
    <v-dialog v-model="editorShownOffice" width="850" persistent>
        <!-- Begin:Content:Mode:update ------------------------------------- -->
        <v-card v-if="editorMode === 'update'" style="border: 1px solid blue;">
            <!-- Card Title ------------------------------------------------ -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-envelope"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected Office List -------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: red; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees/Offices:</strong></div>
            <selected-office-list v-model="employees" v-if="editorShownOffice" />

            <v-divider style="margin-top: 20px;"></v-divider>

           <!-- Selecting Office ------------------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: blue; padding-right: 10px;" class="b-fa b-fa-envelope"></i><strong>Update your Office:</strong></div>
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Office - from:" disabled="false" disabledTime="false" ref="startTimer" />
                <datetime v-model="endDate" label="Office - to:" disabled="false" disabledTime="false" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <airports-combo v-model="aptCode" label="Select Arprt:" />
                    </v-col>

                    <v-col cols="6" class="">
                        <checkbox v-model="requested" label="Requested?" />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Office Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiEvents('OFFICE').length }} Offices(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a"@click="onClose_OfficeDialog">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_OfficeUpdate"> Save</v-btn>
            </v-card-actions>
        </v-card>



        <!-- Begin:Content:Mode:create ------------------------------------- -->
        <v-card v-if="editorMode === 'create'" style="border: 1px solid blue;">
            <!-- Card Title ------------------------------------------------ -->
            <v-card-title class="blue-grey lighten-1 pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: #ffffff;" class="b-fa b-fa-envelope"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} - Multiple ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <!-- Selected Employees List ----------------------------------- -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px; margin-bottom: 0px;"><i style="font-size:15px; color: blue; padding-right: 10px;" class="b-fa b-fa-user"></i><strong>Choose your Employees:</strong></div>
            <selected-employees-list v-model="employees" v-if="editorShownOffice" />

            <v-divider style="margin-top: 0px;"></v-divider>

            <!-- Selecting Office ------------------------------------------ -->
            <div style="font-size: 15px; font-weight: 700; color: #606263; padding-left: 28px; margin-top:15px;"><i style="font-size:15px; color: blue; padding-right: 10px;" class="b-fa b-fa-envelope"></i><strong>Build your Office:</strong></div>
            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Office - from:" disabled="false" disabledTime="false" ref="startTimer" />
                <datetime v-model="endDate" label="Office - to:" disabled="false" disabledTime="false" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <airports-combo v-model="aptCode" label="Select Arprt:" />
                    </v-col>

                    <v-col cols="6" class="">
                        <checkbox v-model="requested" label="Requested?" />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Office Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <!-- Card Actions ---------------------------------------------- -->
            <v-card-actions>
                <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 25px;"><strong>Status: {{ get_selectedMultiResources.length }} Employee(s) in Scheduler selected</strong></span>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClose_OfficeDialog">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_OfficeCreate"> Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import AirportsCombo from '../../AirportsCombo.vue';
    import Checkbox from '../../Checkbox.vue';
    import CommentTextarea from '../../CommentTextarea.vue';
    import SelectedOfficeList from '../../SelectedOfficeList.vue';
    import SelectedEmployeesList from '../../SelectedEmployeesList.vue';

    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-office',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownOffice
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,
            AirportsCombo,
            Checkbox,
            CommentTextarea,
            SelectedOfficeList,
            SelectedEmployeesList

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            startDate       : null,
            endDate         : null,
            // >>> ------------------------------
            idApt           : null, // gets set in: 'get_AirportId'
            aptCode         : null,
            requested       : null,
            // >>> ------------------------------
            dutyComment     : null,
            employees       : [],
            // >>> ------------------------------

        }), // eo function data()
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Computed */
        computed : {

            ...mapGetters([
                'get_selectedMultiResources',
                'get_selectedMultiEvents',
                'get_Airports',
                'get_shared_IsEditingInThePastAllowed'
            ]),


            /*******************************************************************
            * editorShownAvailable()
            *
            * Desc:
            * Note: Distinguishes between editorMode: 'update', 'create'
            *
            */
            editorShownOffice: {

                /***************************************************************
                * get()
                *
                * Desc:
                * Note:
                */
                get: function() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        resourceRecord = me.resourceRecord,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/office/EventEditor.vue >>> editorShownOffice get');
                    if (true === me.value) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName       : this.eventName, // eventRecord.name,
                                    startDate       : new Date(eventRecord.startDate),
                                    endDate         : new Date(eventRecord.endDate),
                                    idApt           : eventRecord.idApt,
                                    aptCode         : eventRecord.aptCode,
                                    requested       : eventRecord.requested,
                                    dutyComment     : eventRecord.dutyComment,
                                });
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            if (resourceRecord) {
                                timestamp = new Date(this.addDate).setHours(0, 0, 0, 0);
                                startDate = new Date(timestamp);
                                timestamp = new Date(this.addDate).setHours(23, 59, 0, 0);
                                endDate = new Date(timestamp);

                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : startDate,
                                    endDate         : endDate,
                                    idApt           : null,
                                    aptCode         : null,
                                    requested       : false,
                                    dutyComment     : null,
                                });
                            }
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo function editorShownOffice get()


                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                */
                set: function(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/office/EventEditor.vue >>> editorShownOffice set');
                    this.$emit('input', value);

                } // eo function editorShownOffice set()

            } // eo editorShownOffice{}

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Listen to: 'updateoffice'.
        * Note: Runs after the instance is created. Installs Listeners.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/office/EventEditor.vue >>> created');
            // eventBus.$on('updateoffice', this.onUpdate_SingleDuty); // call: modify single duty successful
            eventBus.$on('onchangedatepicker', this.onChange_DatePicker); // onChange_DatePicker (not used right now)

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/office/EventEditor.vue >>> beforeDestroy');
            // eventBus.$off('updateoffice', this.onUpdate_SingleDuty);
            eventBus.$off('onchangedatepicker', this.onChange_DatePicker);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_set_SelectedMultiEvents',
                'actn_create_Multiple_Duty',
                'actn_update_Multiple_Duty',
                'actn_update_SingleDuty', // Call: Modify Single Duty
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_OfficeUpdate()
            *
            * Desc:
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_OfficeUpdate: function(){

                let me = this,
                    singleParamObject = {},
                    params = {
                        breaks : []
                    };


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/office/EventEditor.vue >>> onSave_OfficeUpdate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                this.employees.forEach(employee => {
                    singleParamObject = {
                        id: employee.originalId,
                        idResource: employee.resourceId,
                        from: moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        to: moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        type: 'OFFICE',
                        status: 'PLANNED',
                        idApt: this.get_AirportId(me.aptCode),
                        requested: me.requested,
                        dutyComment: me.dutyComment !== '' ? me.dutyComment : null
                    };
                    params.breaks.push(singleParamObject);
                });

                if (this.validateParams(params) === true) {
                    this.actn_update_Multiple_Duty(params);
                }

            }, // eo function onSave_OfficeUpdate()


            /*******************************************************************
            * onSave_OfficeCreate()
            *
            * Desc:
            * Note:
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_OfficeCreate: function(){

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/office/EventEditor.vue >>> onSave_OfficeCreate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id              : null,
                    // idResource      : this.resourceRecord.id,
                    idResources     : this.employees,
                    from            : moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    to              : moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    type            : 'OFFICE',
                    status          : 'PLANNED',
                    idApt           : this.get_AirportId(me.aptCode),
                    requested       : me.requested,
                    dutyComment     : me.dutyComment !== '' ? me.dutyComment : null
                };

                if (this.validateParams(params) === true) {
                    this.actn_create_Multiple_Duty(params);
                    this.actn_set_SelectedMultiEvents([]); // send empty Array
                }

            }, // eo function onSave_OfficeCreate()


            /*******************************************************************
            * onClose_OfficeDialog()
            *
            * Desc: Close 'Office' Dialog.
            * Note: Reset 'all selected Events' here.
            *
            */
            onClose_OfficeDialog: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/office/EventEditor.vue >>> onClose_OfficeDialog');
                this.actn_set_SelectedMultiEvents([]); // send empty Array, #244
                me.editorShownOffice = false;

                eventBus.$emit('schedulerdeselectall'); // #401

            }, // eo function onClose_OfficeDialog()



            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onUpdate_SingleDuty()
            *
            * Desc: Successful Call => emits 'updateoffice' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of call:actn_update_SingleDuty for buildEventNote
            * Note:
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_SingleDuty: function(response){

                let me = this,
                    style = null,
                    tooltipData = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/office/EventEditor.vue >>> onUpdate_SingleDuty');
                me.eventRecord.setStartEndDate(me.startDate, me.endDate);
                me.eventRecord.set({ requested: me.requested });

                me.eventRecord.set({ idApt: me.idApt });
                me.eventRecord.set({ aptCode: me.aptCode });
                me.eventRecord.set({ dutyComment: me.dutyComment });

                tooltipData = me.$buildEventNote(response); // Catch after 'requested was set!: Important
                me.eventRecord.set({ nameEvent: tooltipData.nameEvent });
                me.eventRecord.set({ note: tooltipData.note });

                // >>> Style ----------------------------------------
                if (response.dutyComment !== null) {
                    style = ' border-right: 3px dotted #000;';
                }
                me.eventRecord.set({ style: style });
                // <<< Style ----------------------------------------

                if(!me.eventRecord.eventStore) {
                    me.eventStore.add(me.eventRecord);
                    me.eventRecord.resourceId = me.resourceId;
                }

                // >>> close the editor .. now
                me.editorShownOffice = false;

            }, // eo function onUpdate_SingleDuty()


            /*******************************************************************
            * onChange_DatePicker()
            *
            * Desc: If Start DatePicker changed, it emits an Event and its
            * Desc: new Value to set it to End DatePicker.
            * Note:
            *
            * @param {String} value ()
            */
            onChange_DatePicker: function(value){

                let me = this,
                    newDate = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/office/EventEditor.vue >>> onChange_DatePicker');
                // newDate = new Date(value);
                // newDate.setHours(23);
                // newDate.setMinutes(59);
                // me.endDate = newDate;

            }, // eo function onChange_DatePicker()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams()
            *
            * Desc: Checks/Validates Params before send to Backend.
            * Note: Kind if cascading Validations.
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    a = null,
                    b = null,
                    diffInHours = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/office/EventEditor.vue >>> validateParams');
               // >>> --------------------------- 'aptCode?'                    // Check 1
                if (me.aptCode === null || me.aptCode === undefined) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: Airport is a required field'
                    });
                    valid = false;
                } else {
                    valid = true;
                }
               // <<< ---------------------------


               // >>> --------------------------- 'startDate bef endDate?'      // Check 2
               if (valid === true) {  // still valid
                    startDate = moment(params.from);
                    endDate = moment(params.to);
                    if (endDate.isBefore(startDate)) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: EndDate must be after StartDate.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
               }
               // <<< ---------------------------


                // >>> -------------------------- 'over 10 hours?'              // Check 3
                if (valid === true) {  // still valid
                    a = moment(me.startDate);
                    b = moment(me.endDate);
                    diffInHours = b.diff(a, 'hours');
                    if (diffInHours > 10) {
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: 'Validation: Office Duty can only be max 10 hours long.'
                        });
                        valid = false;
                    } else {
                        valid = true;
                    }
                }


                return valid;

            }, // eo function validateParams()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_AirportId()
            *
            * Desc: Return Airports ID.
            * Note:
            *
            */
            get_AirportId: function(code) {

                let me = this,
                    aptId = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/office/EventEditor.vue >>> get_AirportId');
                this.get_Airports.forEach((apt, i) => {
                    if (apt.aptCode === code) {
                        this.idApt = apt.idAirport;
                        aptId = apt.idAirport;
                    }
                });


                return aptId;

            }, // eo function get_AirportId()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
